module.exports = "/images/Icon industry-LazerTag.svg?5251dd7ce6586ac723916b2b529a2613";